import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import Button from '~/components/commonUi/Button/Button';
import Fieldset from '~/components/commonUi/Fieldset';
import SelectText from '~/components/commonUi/SelectText/SelectText';
import { COPY_COMPLETE_MESSAGE } from '~/consts/candidates';
import { Region } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';

interface Props {
    regions: Region[];
    onChangeRegionForCopy: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    selectedRegionIdForCopy: string;
    onClickCopy: () => void;
    isCopyingCandidateSuccess: boolean;
}

const Copy: FC<Props> = (props) => {
    const getOptions = () => {
        return (
            props.regions.map((option) => ({
                value: option.id,
                label: option.name,
            })) || []
        );
    };

    const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChangeRegionForCopy(event);
    };

    const handleOnClickCopy = () => {
        props.onClickCopy();
    };

    return (
        <Fieldset title="Kopier kandidat til" className="mt-[20px]">
            <form>
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 lg:col-span-10">
                        <div className="grid grid-cols-12 gap-4">
                            <label
                                htmlFor="copy-candidate-select"
                                className="col-span-12 lg:col-span-2 flex items-center font-normal"
                            >
                                Region
                            </label>
                            <div className="col-span-12 lg:col-span-4">
                                <SelectText
                                    options={getOptions()}
                                    onChange={handleOnChange}
                                    testId="copy-candidate-select"
                                    value={props.selectedRegionIdForCopy}
                                    id="copy-candidate-select"
                                    extendedClassName="w-full"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-span-12 lg:col-span-2">
                        <Button
                            btnText="Kopiere"
                            onClick={handleOnClickCopy}
                            testId="copy-candidate-button"
                            title="Kopiere"
                        />
                    </div>
                </div>
                {props.isCopyingCandidateSuccess && (
                    <div className="text-custom-green-01 py-[7px]">{COPY_COMPLETE_MESSAGE}</div>
                )}
            </form>
        </Fieldset>
    );
};

const CopyWithStore = () => {
    const { candidateStore } = getStore();

    useEffect(() => {
        candidateStore.setSelectedRegionIdForCopy(candidateStore.selectedRegionId);
        candidateStore.setIsCopyingCandidateSuccess(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [candidateStore.selectedRegionId]);

    return (
        <Copy
            regions={candidateStore.regions}
            onChangeRegionForCopy={candidateStore.onChangeRegionForCopy}
            selectedRegionIdForCopy={candidateStore.selectedRegionIdForCopy}
            onClickCopy={candidateStore.copyCandidate}
            isCopyingCandidateSuccess={candidateStore.isCopyingCandidateSuccess}
        />
    );
};

export default observer(CopyWithStore);
